<div class="test-case-body" skyTranslationGuard="skypro-python-exercise-test-case-description">
  <div class="test-case-item">
    <span>{{ 'skyproLibsBlocksPythonExerciseTestCase.testData' | transloco }}</span>
    <div class="stdout">
      @for (input of result.inputs; track input; let index = $index) {
      <div>
        <span class="stdout-secondary">{{ index + 1 }}:</span>
        <span class="stdout-primary">'{{ input | skyUiTypograf }}'</span>
      </div>
      }
    </div>
  </div>
  <div class="test-case-item">
    <span>{{ 'skyproLibsBlocksPythonExerciseTestCase.result' | transloco }}</span>
    <pre
      class="stdout"
      [class.success]="result.isSuccessCheck"
      [class.error]="!result.isSuccessCheck"
      >{{ result.actualConsoleOutput }}</pre
    >
  </div>
  <div class="test-case-item">
    <span>{{ 'skyproLibsBlocksPythonExerciseTestCase.expectedResult' | transloco }}</span>
    <pre class="stdout">{{ result.expectedConsoleOutput }}</pre>
  </div>
</div>
